import { Chart } from 'react-google-charts';
import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

function options(haveLegend) {
  return {
    colors: ['green', 'red', 'orange'],
    pieHole: 0.1,
    is3D: true,
    legend: haveLegend ? 'bottom' : 'none',
  };
}

function data(safe, dangerous) {
  return [
    ['Task', 'Hours per Day'],
    ['Güvenli', safe],
    ['Tehlikeli', dangerous],
  ];
}

const PieChart = (props) => {
  const backgroundColor = props.backgroundColor;
  const widthRate = parseFloat(props.widthRate);
  const haveLegend = props.haveLegend;

  const safe = props.safe;
  const dangerous = 100 - safe;

  if (safe == null) {
    return <div />;
  }
  return (
    <Grid item xs={widthRate == null ? 3.5 : widthRate}>
      <Box
        sx={{
          height: '100%',
          backgroundColor: backgroundColor == null ? '#fff' : backgroundColor,
        }}
      >
        <Chart
          chartType="PieChart"
          data={data(safe, dangerous)}
          options={options(haveLegend)}
        />
      </Box>
    </Grid>
  );
};

export default PieChart;
